import styled from "styled-components";
import { Link as LinkR } from 'react-router-dom';


export const HeroSectionContainer = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    scroll-snap-align: start;
`

export const IntroText = styled.h1`
    font-size: 1.8rem;
    color: white;
    font-weight: bolder;
    margin-top: 50px;
    @media (min-width:1281px){
        font-size: 3rem;
    }
`

export const SubText = styled.p`
    color: grey;
    /* margin: 0; */
    margin-right: 35px;
    margin-top: 0;
    font-size: 0.9rem;
`

export const SubTextWrap = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`


export const HeroBtnWrap = styled.div`
    display: flex;
    justify-content: center;
`

export const HeroBtnRoute = styled(LinkR)`
    border-radius: 50px;
    background-color: #256ce1;
    white-space: nowrap;
    padding: 16px 28px;
    color: white;
    text-decoration: none;
    font-size: 0.8rem;
    outline: none;
    border: none;
    cursor: pointer;
    margin-top: 10px;
`

export const HeroImg = styled.img`
    src: ${props => props.src};
    height: 180px;
    width: 180px;

    @media (min-width:1281px){
        height: 240px;
        width: 240px;
    }
`